import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MyDialogDataModel} from '../../../models/my-dialog-data.model';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';

@Component({
    selector: 'app-no-order-items-info',
    templateUrl: './no-order-items-info.component.html',
    styleUrls: ['./no-order-items-info.component.scss']
})
export class NoOrderItemsInfoComponent implements OnInit, OnChanges {

    private model: MyDialogDataModel;

    @Input() connectedTableId: MyContainersTableIdEnum;


    public step3DeviceTableContainersInfoData = {
        title: 'Hardware',
        buttonTitle: 'Hardware hinzufügen',
        message: 'Wenn kein Hardware für dieses Projekt benötigt wird, bitte auf „Weiter“ klicken.'
    };
    public step4AccessoriesTableContainersInfoData = {
        title: 'Zubehör',
        buttonTitle: 'Zubehör hinzufügen',
        message: 'Für dieses Projekt wird kein Zubehör benötigt.'
    };

    public step4WarrantiesTableContainersInfoData = {
        title: 'Full Service Pack',
        buttonTitle: 'Full Service Pack hinzufügen',
        message: 'Für dieses Projekt wird kein Full Service Pack benötigt.'
    };


    public step4ServicesContainersInfoData = {
        title: 'Services',
        buttonTitle: 'Services hinzufügen',
        message: 'Für dieses Projekt wird kein Service benötigt.'
    };

    public step4UpgradesContainersInfoData = {
        title: 'Upgrades',
        buttonTitle: 'Upgrades hinzufügen',
        message: 'Für dieses Projekt werden keine Upgrades benötigt.'
    };

    public infoData = this.step3DeviceTableContainersInfoData;


    constructor(
        public editModalService: EditModalService
    ) {
    }

    ngOnInit(): void {
        this.model = this.editModalService.getDialogModel();
    }


    public onActivateItemsOrder() {

        switch (this.connectedTableId) {
            case MyContainersTableIdEnum.step3DeviceTableContainers:
                this.model.isDeviceOrderRequested = true;
                break;
            case MyContainersTableIdEnum.step4AccessoriesTableContainers:
                this.model.isAccessoryOrderRequested = true;
                break;
            case MyContainersTableIdEnum.step4WarrantiesTableContainers:
                this.model.isWarrantyOrderRequested = true;
                break;
            case MyContainersTableIdEnum.step4ServicesContainers:
                this.model.isServiceOrderRequested = true;
                break;
            case MyContainersTableIdEnum.step4UpgradesContainers:
                this.model.isUpgradesOrderRequested = true;
                break;
            default:
                console.warn('unexpected table type enum value', MyContainersTableIdEnum[this.connectedTableId]);
        }

        this.editModalService.announceTableContentChanged(MyContainersTableIdEnum.allTablesContainers);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['connectedTableId']) {
            const variableName = MyContainersTableIdEnum[this.connectedTableId] + 'InfoData';
           // console.log('variableName', variableName, this[variableName]);

            this.infoData = this[variableName];
        }
    }


    public getInfoIconText(): string {
        switch (this.connectedTableId) {
            case MyContainersTableIdEnum.step4ServicesContainers:
                return 'Wir bieten Ihnen für die Hardware u.a. folgende Möglichkeiten: Konfiguration, Aktivierung von Upgrades, Aktivierung der BSI Schnittstelle, Deaktivierung von Gerätefunktionen.';
            case MyContainersTableIdEnum.step4UpgradesContainers:
                return 'Die Brother Upgrades erweitern schnell und einfach den Funktionsumfang ausgewählter Drucker und Dokumentenscanner. Detaillierte Informationen erhalten Sie über www.brother.de oder über Ihren Brother Ansprechpartner.';
            default:
                return '';
        }

        return 'comment is not defined';
    }

    public isInfoIconVisible(): boolean {
        return this.connectedTableId === MyContainersTableIdEnum.step4ServicesContainers || this.connectedTableId === MyContainersTableIdEnum.step4UpgradesContainers;
    }
}
